import { CountUp } from 'countup.js';

export const counterAnimation = () => {

  const counters = document.querySelectorAll('.js-counter');

  if (!counters.length) return;

  const observer = new IntersectionObserver(
    (entries, observer) => {

      entries.forEach((entry) => {

        if (!entry.isIntersecting) return;

        const counter = entry.target;

        const endValue = Number(counter.dataset.count);

        const countUp = new CountUp(
          counter,
          endValue,
          {
            duration: 4,
            separator: ',',
            suffix: counter.dataset.suffix || '',
          }
        );

        if (!countUp.error) {
          countUp.start();
        }

        observer.unobserve(counter);

      });

    },
    {
      threshold: 0.4,
    }
  );

  counters.forEach((counter) => {
    observer.observe(counter);
  });

};